define('services/groupService',[
    'lib/lodash4',
    'lib/bluebird',
    'lib/knockout',

    'models/Group',

    'services/apiCore'
], function(
    _,
    Promise,
    ko,

    Group,

    apiCore

    ){
    "use strict";

    var PATH_DELIMITER = '{0}',
        PATH_GROUPS = '/groups',
        PATH_GROUP  = PATH_GROUPS + '/' + PATH_DELIMITER,
        PATH_GROUPS_SEARCH = PATH_GROUPS + '/search';

        return {

            /**
             * Gets a list of groups.
             * @param options - The params to include - structured like {
             *     pageNumber : 1,
             *     pageSize   : 25,
             *     name       : '*'
             * }
             * @returns {*} - array of "models/Group" objects
             */
            getGroups: function( options ) {
                var params = _.assign( {
                    pageNumber : 1,
                    pageSize   : 25,
                    name       : '*'
                }, options );
                return apiCore.v2.get( PATH_GROUPS ,params )
                    .then( function( response ){
                        response.entities =  _.map(response.entities, function( groupData ){
                           return new Group( groupData );
                       });
                        return response;
                    });
            },

            /**
             *  Gets a group based on the group's guid
             * @param groupId - the guid of the group
             * @returns {*}
             */
            getGroup : function( groupId ) {
                return apiCore.v2.get( PATH_GROUP.replace( PATH_DELIMITER, groupId ) )
                    .then( function( groupData ){
                        return new Group( groupData );
                    });
            },


            /**
             * Searches for groups that meet the criteria of the query
             *
             * @param {object} query
             *
             * @returns {*} - array of "models/Group" objects
             */
            searchGroups: function (query) {
                return apiCore.v2.post(PATH_GROUPS_SEARCH, query)
                    .then(function (response) {
                        return _.map(response.results, function( groupData ){
                           return new Group( groupData );
                       });
                    });
            }
        };
});

